import { render } from "./WatchlistRemove.vue?vue&type=template&id=7df307b4&scoped=true"
import script from "./WatchlistRemove.vue?vue&type=script&lang=js"
export * from "./WatchlistRemove.vue?vue&type=script&lang=js"

import "./WatchlistRemove.vue?vue&type=style&index=0&id=7df307b4&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df307b4"]])

export default __exports__